import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import styles from "./userPaymentSuccessRedirectStyles";
import UserPaymentSuccessRedirectView from "./userPaymentSuccessRedirectView";
import ApiPayments from "../../../API/ApiPayments";
import generateGameCodePdf from "../../../utils/generateGameCodePdf";
import { withTranslation } from "react-i18next";

// Le code est créé par le webhook Stripe, qui peut arriver après la
// redirection de l'acheteur : on laisse ~20 s au back avant d'abandonner.
const POLL_INTERVAL_MS = 2000;
const MAX_POLL_ATTEMPTS = 10;

class UserPaymentSuccessRedirectComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      hasError: false,
      isWaitingForCode: false,
      codeGenerationTimedOut: false,
      isGeneratingPdf: false,
      pdfError: false,
      tourTitle: "",
      contactEmail: "",
      buyerEmail: "",
      code: null,
      customText: "",
      iconUrl: "",
      status: null,
    };

    // Le sessionId reste dans une propriété d'instance plutôt que dans le
    // state : c'est un secret de session, il n'a pas à transiter par le rendu.
    this.paymentLinkId = null;
    this.stripeSessionId = null;
    this.pollTimeout = null;
    this.isUnmounted = false;

    this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
  }

  componentDidMount() {
    document.title = "Paiement réussi | Landing Zone";
    this.readParamsAndLoad();
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    if (this.pollTimeout) clearTimeout(this.pollTimeout);
  }

  /**
   * Le stripe_session_id est un secret de session : il ne doit ni rester dans
   * l'URL (historique, fuite via l'en-tête Referer vers des tiers) ni finir
   * dans un log. On le lit une fois, on le retire de la barre d'adresse, puis
   * on ne le manipule plus qu'en mémoire.
   */
  readParamsAndLoad() {
    const params = new URLSearchParams(this.props.location.search);
    this.paymentLinkId = params.get("paymentLinkId");
    this.stripeSessionId = params.get("stripe_session_id");

    if (this.stripeSessionId) {
      params.delete("stripe_session_id");
      const query = params.toString();
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}${query ? `?${query}` : ""}`
      );
    }

    if (!this.paymentLinkId || !this.stripeSessionId) {
      this.setState({ isLoading: false, hasError: true });
      return;
    }

    this.fetchPaymentSuccessInfo(1);
  }

  async fetchPaymentSuccessInfo(attempt) {
    const response = await ApiPayments.getPaymentSuccessInfo(
      this.paymentLinkId,
      this.stripeSessionId
    );

    if (this.isUnmounted) return;

    if (response.status !== 200 || !response.data) {
      // 404 = session inconnue ou non payée. On reste volontairement générique :
      // aucun détail sur la raison, et surtout aucune trace de l'identifiant.
      this.setState({ isLoading: false, hasError: true });
      return;
    }

    const {
      tourTitle,
      contactEmail,
      buyerEmail,
      code,
      customText,
      iconUrl,
      status,
    } = response.data;

    this.setState({
      isLoading: false,
      hasError: false,
      tourTitle: tourTitle || "",
      contactEmail: contactEmail || "",
      buyerEmail: buyerEmail || "",
      code: code || null,
      customText: customText || "",
      iconUrl: iconUrl || "",
      status: status || null,
    });

    if (code) {
      this.setState({ isWaitingForCode: false, codeGenerationTimedOut: false });
      return;
    }

    if (attempt >= MAX_POLL_ATTEMPTS) {
      this.setState({ isWaitingForCode: false, codeGenerationTimedOut: true });
      return;
    }

    this.setState({ isWaitingForCode: true });
    this.pollTimeout = setTimeout(() => {
      if (!this.isUnmounted) this.fetchPaymentSuccessInfo(attempt + 1);
    }, POLL_INTERVAL_MS);
  }

  async handleDownloadPdf() {
    const { t } = this.props;

    if (!this.state.code) return;

    this.setState({ isGeneratingPdf: true, pdfError: false });

    try {
      await generateGameCodePdf({
        tourTitle: this.state.tourTitle,
        code: this.state.code,
        customText: this.state.customText,
        contactEmail: this.state.contactEmail,
        iconUrl: this.state.iconUrl,
        t,
      });
      this.setState({ isGeneratingPdf: false });
    } catch (error) {
      this.setState({ isGeneratingPdf: false, pdfError: true });
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <UserPaymentSuccessRedirectView
        {...this.props}
        state={this.state}
        classes={classes}
        handleDownloadPdf={this.handleDownloadPdf}
      />
    );
  }
}

export default withTranslation()(
  withStyles(styles, { withTheme: true })(
    withRouter(UserPaymentSuccessRedirectComponent)
  )
);
